define('queryStringConfig',['amenitiesList', 'homeStatusList'], (amenitiesList, homeStatusList) => {
  'use strict';

  function addQueryString(parameters, value) {
    const index = parameters.indexOf(value);

    if (index >= 0 || !value) {
      return;
    }

    parameters.push(value);
  }

  function removeQueryString(parameters, value) {
    const index = parameters.indexOf(value);

    if (index === -1 || value === '') {
      return;
    }

    parameters.splice(index, 1);
  }

  function processQueryString(parameters, value, key) {
    const query = amenitiesList.getQuery(key);

    if (value) {
      addQueryString(parameters, query);
    } else {
      removeQueryString(parameters, query);
    }
  }

  const queryStringConfigs = {
    Adult(parameters, value) {
      processQueryString(parameters, value, 'Adult');
    },
    AgeRestricted(parameters, value) {
      processQueryString(parameters, value, 'AgeRestricted');
    },
    CommunityStatus(parameters, value) {
      processQueryString(parameters, value, 'CoomingSoon');
    },
    Gated(parameters, value) {
      processQueryString(parameters, value, 'Gated');
    },
    GolfCourse(parameters, value) {
      processQueryString(parameters, value, 'GolfCourse');
    },
    Green(parameters, value) {
      processQueryString(parameters, value, 'Green');
    },
    HomeStatus(parameters, value) {
      const HomeStatusAmenities = homeStatusList.getAmenitiesFromHomeStatus(value);
      Object.keys(HomeStatusAmenities).forEach((amenity) => {
        const amenityValue = HomeStatusAmenities[amenity];
        processQueryString(parameters, amenityValue, amenity);
      });
    },
    LuxuryHomes(parameters, value) {
      processQueryString(parameters, value, 'LuxuryHomes');
    },
    NatureAreas(parameters, value) {
      processQueryString(parameters, value, 'NatureAreas');
    },
    Parks(parameters, value) {
      processQueryString(parameters, value, 'Parks');
    },
    Pool(parameters, value) {
      processQueryString(parameters, value, 'Pool');
    },
    Qmi(parameters, value) {
      processQueryString(parameters, value, 'Qmi');
    },
    SingleFamily(parameters, value) {
      processQueryString(parameters, value, 'SingleFamily');
    },
    Sports(parameters, value) {
      processQueryString(parameters, value, 'Sports');
    },
    Views(parameters, value) {
      processQueryString(parameters, value, 'Views');
    },
    Waterfront(parameters, value) {
      processQueryString(parameters, value, 'Waterfront');
    },
    HasRVGarage(parameters, value) {
      processQueryString(parameters, value, 'HasRVGarage');
    }
  };

  function getConfigurationForQueryStrings(parameters, key, value) {
    const queryString = queryStringConfigs[key];

    if (typeof queryString !== 'function') {
      return false;
    }

    const length = parameters.length;
    queryString(parameters, value);
    return parameters.length > length;
  }

  return {
    getQueryString: getConfigurationForQueryStrings
  };
});

